import React from 'react';
import { Formik, Form, Field, ErrorMessage } from "formik";
import { useContext , useEffect , } from "react";
import { expertContext } from "../../../../context/expertcontext";
import Steps from "./Steps";

const Final = ({info,desc}) => {
    const { setTab, tab , description,setDescription} = useContext(expertContext);

    const nextStep = (values) => {
      if (tab < 7) {
        setTab(tab + 1);
      }
    };
    const previousStep = (values) => {
      if (tab > 1) {
        setTab(tab - 1);
      }
    };
    return (
        <div>
        <Formik
          initialValues={{
            description: description || ""
          }}
          validationSchema={""}
          onSubmit={(values, { resetForm }) => {
            nextStep()
            setDescription(values.description)
          }}
          enableReinitialize={true}
        >
          {({
            isSubmitting,
            errors,
            setFieldValue,
            handleChange,
            values,
            resetForm,
          }) => (
            <Form>
              <div className="soratkarshenasi-form">
                <div className="row align-items-center ">
                <div className="mb-3 col-12 ">
                <label
                  className="mb-1 ms-2 d-flex label-form karshenasi-label"
                  htmlFor="description"
                >
                  توضیحات
                </label>
                <Field
                  className="w-100 karshenasi-input px-2"
                  name='description'
                  as='textarea'
                  style={{height:"150px" , resize:"none"}}
                />
                <ErrorMessage
                  name='description'
                  render={(msg) => <div className="text-danger">{msg}</div>}
                />
              </div>
                  <div className="mb-3 col-12 ">
                    <label
                      className="mb-1 ms-2 d-flex label-form karshenasi-label"
                      htmlFor="description"
                    >
                      لیست توضیحات بیشتر
                    </label>
                    <Field
                      as="select"
                      className="w-100 karshenasi-input px-2"
                      name='description'
                    >
                      <option>لطفا یک گزینه انتخاب کنید</option>
                      {desc.map((s, index) => (
                        <option key={index} value={s.name}>
                          {s.name}
                        </option>
                      ))}
                    </Field>
                    <ErrorMessage
                      name='description'
                      render={(msg) => <div className="text-danger">{msg}</div>}
                    />
                  </div>
                 
                </div>
              </div>
  
              <div>
                <Steps />
                <div className="mb-2 px-2 d-flex justify-content-between">
                  <div className=" request-next-btn-box mt-2">
                    <button type="submit" className="btn request-next-btn">
                      بعدی
                    </button>
                  </div>
                  <div className=" request-Previous-btn-box mt-2">
                    <button
                      className="btn request-Previous-btn "
                      type="button"
                      onClick={() => {
                        previousStep();
                      }}
                    >
                      قبلی
                    </button>
                  </div>
                </div>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    );
};

export default Final;